import Slider from "react-slick";
import Image_Hire from '../../assets/images/undraw_hire_hadq(1).svg';
import Image_JobOffer from '../../assets/images/undraw_job-offers_55y0(1).svg';
import Image_PersonalLife from '../../assets/images/undraw_personal-file_81l0(1).svg';
import Image_UpdatedResume from '../../assets/images/undraw_updated-resume_287i(1).svg';

const IllustrationPanel = () => {
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        customPaging: () => (
        <div className="w-3 h-1 rounded-full bg-gray-300 mt-2" />
        ),
        appendDots: (dots) => (
        <div className="mt-6 flex justify-center space-x-1">{dots}</div>
        ),
    };

    const slides = [
        {
          img: Image_Hire,
          title: "Onboarding New Talent with Digital HRMS",
          subtitle: "Everything you need in an easily customizable dashboard",
        },
        {
          img: Image_JobOffer,
          title: "Streamlined Job Offer Management",
          subtitle: "Create, send, and track job offers effortlessly",
        },
        {
          img: Image_PersonalLife,
          title: "Work-Life Balance Insights",
          subtitle: "Monitor and support employee wellbeing and productivity",
        },
        {
          img: Image_UpdatedResume,
          title: "Keep Employee Records Up-To-Date",
          subtitle: "Easily manage updated resumes and skill data",
        },
    ];
      
    

    return (
    <div className="hidden md:flex md:w-1/2 items-center justify-center p-8 m-14 bg-gray-100 dark:bg-black rounded-2xl">
        <div className="text-center max-w-md w-full">
            <Slider {...settings}>
            {slides.map((slide, index) => (
                <div key={index}>
                <img src={slide.img} alt="Illustration" className="w-full max-w-xs mx-auto" />
                <h2 className="text-lg font-semibold mt-6 text-gray-600 dark:text-white">{slide.title}</h2>
                <p className="text-sm mt-2 text-gray-600 dark:text-white">{slide.subtitle}</p>
                </div>
            ))}
            </Slider>
        </div>
    </div>
  );
};

export default IllustrationPanel;
